import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.proj_user_assigned_uid !== model.proj_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.proj_user_modified_uid,
						assignedTo: modifiedModel.proj_user_assigned_uid,
						title: 'Nuovo Progetto assegnato',
						body: `${model.user_modified_title} ti ha assegnato a "${model.proj_title}".`,
						url: `${window.location.origin}/projects/details/${model.proj_uid}`,
						icon: 'clipboard-text-outline',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
